export default __webpack_public_path__ + "static/media/ms365.svg";